'use strict';

require('../modules/forms/forms');
require('./partnerFromUserForm');
require('../models/discipline/discipline');
require('../models/competition/competitionType');
require('../models/event/eventStatus');
require('../models/partners/partners');
require('../helpers/show-modal-message/show-modal-message');

angular.module('far.forms.competitionRequestForm', [
        'dekky.forms',
        'far.forms.partnerFromUserForm',
        'far.models.discipline',
        'far.models.competition.competitionType',
        'far.models.event.status',
        'far.models.partners',
        'far.helpers.showModalMessage'
    ])
    .service('competitionRequestForm', function (form, partnerFromUserForm, fileUploadFilters, Discipline, partners, showModalMessage, autocomplete, CompetitionType, eventStatus) {
        var competitionRequestForm = form('competitionRequestForm');
        var competitionTypeList = CompetitionType.list;

        competitionRequestForm
            .addField('accepted', 'selectObject', {
                validators: {
                    required: true
                },
                options: {
                    defaultOption: 'Статус соревнования',
                    class: 'form__item form__item_select width-350'
                },
                ngOptions: 'item as item.status for item in field.items track by item.id'
            }, eventStatus.list)
            .addField('disciplines', 'selectObject', {
                validators: {
                    required: true
                },
                options: {
                    defaultOption: 'Дисциплина',
                    class: 'form__item form__item_select width-350',
                    ngChange: 'field.ngChange(model)'
                },
                ngOptions: 'item as item.name for item in field.items track by item.id',
                fieldData: {
                    ngChange: function (item) {
                        if (angular.isObject(item)) {
                            competitionRequestForm.$fields.event_competition_type.items = competitionTypeList[item.system_name];
                        }
                    }
                }
            }, Discipline.list)
            .addField('event_competition_type', 'checkboxCollection', {
                checkbox: {
                    label: 'name',
                    model: 'selected'
                },
                checkboxAttributes: {
                    ngChange: 'field.ngChange(item, field)'
                },
                fieldData: {
                    ngChange: function (item, field) {

                    }
                }
            }, [])
            .addField('date_from', 'dateDropdowns', {
                validators: {
                    required: true
                }
            })
            .addField('date_to', 'dateDropdowns', {
                validators: {
                    required: true
                }
            })
            .addField('location', null, {
                validators: {
                    required: true
                }
            })
            .addField('camp', 'uiSelect', {
                validators: {
                    required: false
                },
                options: {
                    onSelect: 'field.uiSelectOptions.onSelect($item, $model)',
                    class: 'form__ui-select width-600'
                },
                uiSelectOptions: {
                    matchTitle: '{{ $select.selected.name }} ',
                    choicesTitle: '{{ item.name }}',
                    match: {
                        placeholder: 'Альплагерь',
                        allowClear: true
                    },
                    choices: {
                        repeat: 'item in field.items track by item.id',
                        refresh: 'field.uiSelectOptions.refreshAutoComplete($select.search, "Camp", "camp")',
                        refreshDelay: 0
                    },
                    refreshAutoComplete: autocomplete.refreshAutoComplete
                }
            }, autocomplete.get('camp'))
            .addField('name', null, {
                validators: {
                    required: true
                },
                options: {
                    placeholder: 'Название соревнования',
                    class: 'form__item'
                }
            })
            .addField('brief', 'textarea', {
                validators: {
                    required: true
                },
                options: {
                    placeholder: 'Анонс',
                    class: 'form__item',
                    maxlength: 150
                }
            })
            .addField('description', 'textarea', {
                validators: {
                    required: true
                },
                options: {
                    redactor: true,
                    placeholder: 'Ваше описание',
                    class: 'form__item'
                }
            })
            .addField('club', 'uiSelect', {
                validators: {
                    required: true
                },
                options: {
                    onSelect: 'field.uiSelectOptions.onSelect($item, $model)',
                    class: 'form__ui-select'
                },
                uiSelectOptions: {
                    matchTitle: '{{ $select.selected.name }} ',
                    choicesTitle: '{{ item.name }}',
                    match: {
                        placeholder: 'Федерация / Клуб',
                        allowClear: true
                    },
                    choices: {
                        repeat: 'item in field.items track by item.id',
                        refresh: 'field.uiSelectOptions.refreshAutoComplete($select.search, "Club", "club")',
                        refreshDelay: 0
                    },
                    refreshAutoComplete: autocomplete.refreshAutoComplete
                }
            }, autocomplete.get('club'))
            .addField('user_director', 'userSelect', {
                validators: {
                    required: true
                },
                options: {
                    class: 'form__ui-select'
                },
                uiSelectOptions: {
                    match: {
                        placeholder: 'Директор, ФИО'
                    },
                    choices: {
                        refresh: 'field.uiSelectOptions.refreshAutoComplete($select.search, "Users", "user_director")'
                    },
                    refreshAutoComplete: autocomplete.refreshAutoComplete
                }
            }, autocomplete.get('user_director'))
            .addField('user_main_judge', 'userSelect', {
                validators: {
                    required: true
                },
                options: {
                    class: 'form__ui-select'
                },
                uiSelectOptions: {
                    match: {
                        placeholder: 'Главный судья, ФИО'
                    },
                    choices: {
                        refresh: 'field.uiSelectOptions.refreshAutoComplete($select.search, "Users", "user_main_judge")'
                    },
                    refreshAutoComplete: autocomplete.refreshAutoComplete
                }
            }, autocomplete.get('user_main_judge'))
            .addField('partners', 'checkboxCollection', {
                options: {
                    class: 'form-group_quarter'
                },
                checkbox: {
                    label: 'name',
                    model: 'selected'
                }
            }, partners.list)
            .addField('documentsFiles', 'fileUpload', {
                validators: {
                    required: true
                },
                label: 'Загрузить файл',
                uploader: {
                    url: Routing.generate('api_upload_post_file'),
                    autoUpload: true,
                    filters: [
                        fileUploadFilters.fileSize(),
                        fileUploadFilters.fileType()
                    ],
                    onSuccessItem: function (item, response) {
                        item.serverData = response;
                    },
                    onWhenAddingFileFailed: function (item, filter) {
                        var message = filter.message ? filter.message : 'Невозможно загрузить файл на сервер';
                        showModalMessage(message);
                    }
                }
            })
            .addField('backgroundImage', 'imageUpload', {
                validators: {
                    required: true
                },
                label: 'Загрузить фото',
                uploader: {
                    url: Routing.generate('api_upload_post_image'),
                    autoUpload: true,
                    queueLimit: 1,
                    onSuccessItem: function (item, response) {
                        item.serverData = response;
                    },
                    onWhenAddingFileFailed: function (item, filter) {
                        var message = filter.message ? filter.message : 'Невозможно загрузить файл на сервер';

                        if (filter.name == 'queueLimit') {
                            message = 'Вы можете загрузить только одно фоновое изображение';
                        }

                        showModalMessage(message);
                    }
                }
            });

        return competitionRequestForm;
    });
